module.exports = __webpack_public_path__ + "static/img/model_img1.7faf750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model_img1.jpg
// module id = 1148
// module chunks = 1